export const getViognierFranceData = () => ({
  name: "Viognier",
  country: "France",
  description: "Le Viognier est un cépage blanc principalement cultivé dans la vallée du Rhône, produisant des vins blancs aromatiques et complexes.",
  regions: [
    { name: "Condrieu", area: "150 ha", percentage: "40%", description: "Appellation phare" },
    { name: "Côte-Rôtie", area: "50 ha", percentage: "13%", description: "Assemblage avec Syrah" },
    { name: "Château-Grillet", area: "4 ha", percentage: "1%", description: "Monocépage" },
    { name: "Languedoc-Roussillon", area: "100 ha", percentage: "27%", description: "Vins de pays" },
    { name: "Autres", area: "66 ha", percentage: "19%", description: "Dispersé dans le sud" }
  ],
  mapAreas: [
    { region: "Condrieu", x: 60, y: 45, color: "#4B164C", size: 5 },
    { region: "Côte-Rôtie", x: 54, y: 64, color: "#6d2c7a", size: 4 },
    { region: "Château-Grillet", x: 59, y: 46, color: "#8a4a8a", size: 3 },
    { region: "Languedoc-Roussillon", x: 50, y: 65, color: "#a768a6", size: 4 }
  ],
  subregions: {
    rhone: {
      name: "Rhône",
      description: "Le Viognier du Rhône produit des vins blancs aromatiques et complexes, avec des notes florales caractéristiques.",
      characteristics: {
        aromas: "Fleurs blanches, abricot, pêche, notes de musc, épices douces",
        body: "Corps moyen à plein",
        tannins: "Pas de tannins (cépage blanc)",
        aging: "Vieillissement court à moyen (3-8 ans)"
      },
      terroir: {
        climate: "Climat continental avec influence méditerranéenne",
        soil: "Sols granitiques et micaschiste",
        viticulture: "Rendements très limités, vendanges manuelles"
      },
      differentiators: [
        "Aromatique intense et complexe",
        "Notes florales caractéristiques",
        "Style élégant et raffiné",
        "Expression terroir unique"
      ],
      foodPairing: "Poissons, fruits de mer, volailles, fromages doux, cuisine asiatique"
    }
  }
}); 